<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">NO. Invoice</th>
          <th scope="col">Total</th>
          <th scope="col">Tanggal</th>
        </tr>
      </thead>
      <tbody
        v-for="(list, index) in items"
        :key="`parent-${index}`"
        class="border-0"
      >
        <tr
          v-for="(item, index) in list.items"
          :key="`child-${index}`"
        >
          <td
            class=" text-primary"
            role="button"
            @click="goToDetailInvoice(item.reference.uuid)"
          >
            {{ item.reference.invoice_number }}
          </td>
          <td class="">{{ formatToRupiah(item.total) }}</td>
          <td class="">{{ list.created_at | formatDateWithTime }}</td>
        </tr>
        <!-- <tr class="mt-1">
          <td
            colspan="4"
            class="border-0"
          >
            <h6
              class="font-weight-bolder mb-0 text-right"
              style="padding: 0 0.7rem"
            >
              Total {{ formatToRupiah(list.total) }}
            </h6>
          </td>
        </tr> -->
      </tbody>
      <tbody v-if="detailResultList.length === 0">
        <tr>
          <td
            colspan="4"
            class="text-center"
          >
            Data kosong.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { BRow, BCol, BDropdown } from 'bootstrap-vue';

import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';

export default {
  name: 'UtangPayments',
  components: {
    BRow,
    BCol,
    BDropdown,
    AppCollapse,
    AppCollapseItem,
  },
  props: ['items'],
  data() {
    return {
      detailResultList: [
        {
          cash_total_payment: 1300000,
          cash_change: 100000,
          total: 1200000,
          items: [
            {
              uuid: '18113973-4f4e-4a39-bdf6-18ef5a9a361e',
              no_invoice: 'INV/054/2025/02/13/0002',
              date: '15/04/2025',
              payment_number: 36238,
              subject: {
                formatted_id: '#10430',
                uuid: '815680ed-63eb-4e5e-ad18-40a846964185',
                customer_type: 'Toko',
                email: null,
                name: 'test deposit',
                alias_name: null,
                phone_number: '6285637373737',
              },
              reference: {
                uuid: '72b2aeec-ef0e-41d1-a567-440f35d00915',
                invoice_number: 'INV/054/022/2025/02/0005',
                date: '13 Feb 2025',
                branch: {
                  name: 'Bandung',
                },
              },
              total: 800000,
            },
            {
              uuid: 'fa269d2c-cfd2-40d6-84fb-537665a9ac9d',
              no_invoice: 'INV/054/2025/02/16/0001',
              date: '15/04/2025',
              payment_number: 36239,
              subject: {
                formatted_id: '#10430',
                uuid: '815680ed-63eb-4e5e-ad18-40a846964185',
                customer_type: 'Toko',
                email: null,
                name: 'test deposit',
                alias_name: null,
                phone_number: '6285637373737',
              },
              reference: {
                uuid: 'f133dd6a-705e-4e76-b539-128641797150',
                invoice_number: 'INV/054/023/2025/02/0015',
                date: '16 Feb 2025',
                branch: {
                  name: 'Toko berkah jaya pertama',
                },
              },
              total: 400000,
            },
          ],
        },
      ],
      result: null,
    };
  },
  methods: {
    goToDetailInvoice(uuid) {
      this.$router.push({
        name: 'invoice.index',
        params: { id: uuid, q: 'utang' },
        query: { page: 1 },
      });
    },
    formatToRupiah(amount) {
      const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      });
      return formatter.format(amount);
    },
  },
};
</script>
